import { useQuery, useMutation } from "urql";

const COMPANY = `
query get_company($id: String!){
    Company(id:$id){
        id,
        name,
        rut,
        clientPaymentDays,
        providerPaymentDays,
        alias,
        plan,
        reports{
            name,
            url
        }
  }
}
`;

export const GetCompanyData = id => {
  const [result, reexecuteQuery] = useQuery({
    query: COMPANY,
    variables: { id },
  });
  const { data, fetching, error } = result;
  return { data, fetching, error, reexecuteQuery };
};


const CREATE_COMPANY = `
mutation CREATE_COMPANY($input: CompanyInput!, $voucher: String) {
	createCompany(input: $input, voucher: $voucher) {
		id
	}
}`;

export const CreateCompany = () => {
  const [result, executeMutation] = useMutation(CREATE_COMPANY)
  const { data, fetching, error } = result;
  return { data, fetching, error, executeMutation }
}

const UPDATE_COMPANY = `
mutation UPDATE_COMPANY($input: UpdateCompanyInput!, $id: String!) {
	updateCompany(input: $input, id: $id) {
		id
	}
}`;

export const UpdateCompany = () => {
  const [result, executeMutation] = useMutation(UPDATE_COMPANY)
  const { data, fetching, error } = result;
  return { data, fetching, error, executeMutation }
}

const PAYMENT_SUCCESSFUL = `
mutation PAYMENT_SUCCESSFUL($companyId: String!, $suscriptionId: String!) {
	paymentSuccessful(companyId: $companyId, suscriptionId: $suscriptionId)
}`;

export const PaymentSuccessful = () => {
  const [result, executeMutation] = useMutation(PAYMENT_SUCCESSFUL)
  const { data, fetching, error } = result;
  return { data, fetching, error, executeMutation }
}


const USER_COMPANY_ROLE = `
query getUserCompanyRole($companyId: String!){
  getUserCompanyRole(companyId:$companyId){
    role
  }
}
`;

export const GetUserCompanyRole = ({companyId}) => {
  const [result, reexecuteQuery] = useQuery({
    query: USER_COMPANY_ROLE,
    variables: { companyId },
  });
  const { data, fetching, error } = result;
  return { data, fetching, error, reexecuteQuery };
};

const ALL_USER_BY_COMPANY = `
  query AllUsersByCompany($companyId: String!) {
    allUsersByCompany(companyId:$companyId) {
        id
        name
        email
    }
}
`;

export const GetAllUserByCompany = ({companyId}) => {
  const [result, reexecuteQuery] = useQuery({
    query: ALL_USER_BY_COMPANY,
    variables: { companyId },
  });
  const { data, fetching, error } = result;
  return { data, fetching, error, reexecuteQuery };
};